var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLauncher)?_c('button',{staticClass:"freshdesk-launcher",on:{"click":function($event){_vm.openFreshdeskWidget(_vm.loggedInEmployee, _vm.currentCompany)()}}},[_vm._v(" "+_vm._s(_vm.$t('button.needHelp'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }